<script lang="ts" setup>
import type { NuxtLinkProps } from "#app";
import type { Schemas } from "#shopware";

type LandingPageLinkProps = NuxtLinkProps & {
  openInDialog?: boolean;
  title?: string;
};

const { search } = useLandingSearch();
const props = withDefaults(defineProps<LandingPageLinkProps>(), {
  openInDialog: false,
  title: "",
});

const content = ref<Schemas["LandingPage"]>();
const landingPageId = "0196f21ed8d777fbbbd8e73d129f050a";

// Create modal controller
const modalController = useModal();

// Load landing page data on component mount
const { apiClient } = useShopwareContext();
onMounted(async () => {
  if (props.openInDialog) {
    try {
      const response = await apiClient.invoke(
        "getShippingContent get /get-shipping-costs",
        {
          pathParams: {},
        }
      );
      if (
        (response.data.success = true && response.data?.shippingCostsPageId)
      ) {
        const landingPageData = await search(
          response.data?.shippingCostsPageId,
          {
            withCmsAssociations: true,
          }
        );

        if (landingPageData && landingPageData.cmsPage) {
          content.value = landingPageData;
        }
      }
    } catch (error) {
      console.error(`Failed to load landing page on mount:`, error);
    }
  }
});
</script>

<template>
  <NuxtLink @click="modalController.open">
    <slot></slot>
    <Teleport to="body">
      <SharedModal :controller="modalController">
        <div class="mt-5">
          <template v-for="section in content?.cmsPage?.sections">
            <CmsGenericBlock
              v-for="cmsBlock in section.blocks"
              :key="cmsBlock.id"
              :content="cmsBlock"
            />
          </template>
        </div>
      </SharedModal>
    </Teleport>
  </NuxtLink>
</template>
